<template>
  <div id="content">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div v-show="events.length !== 0" class="item-listing list">
                <div class="item" v-for="(event, index) in paginatedEvents" :key="index"
                  style="background-color: inherit">
                  <CustomEventRow
                    :event="event"
                    :siteConfiguration="siteConfiguration">
                  </CustomEventRow>
                </div>

                <div class="d-flex justify-content-center mb-3">
                  <b-spinner label="Loading..." v-show="totalEvents === null"></b-spinner>
                </div>
              </div>
            </div>
          </div>

          <b-alert show v-show="events.length === 0 && !loading" style="background-color: #fff;">
            <h6> There are no events available. </h6>
          </b-alert>

          <b-row align-v="center" v-show="totalEvents > eventsToDisplay">
            <b-col md="10" offset-md="1" align="center">
              <div class="more-shows" @click="displayMoreEvents()">
                More Shows
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <script v-html="eventStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import CustomEventRow from './CustomEventRow.vue'
import StructuredData from '../../common/StructuredData'
import GA from '../../common/GA'
import EventPublicService from '../../../services/EventPublicService'

export default {
  name: 'CustomEventsList',
  mixins: [StructuredData, GA],
  components: {
    CustomEventRow
  },
  props: {
    siteConfiguration: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1,
      perPage: 20,
      eventsToDisplay: 20,
      filterByTitle: '',
      filterByEventType: '',
      filterByEventTopic: '',
      loading: true,
      events: [],
      moment: moment,
      eventStructuredData: {},
      totalEvents: 0,
      pagePath: this.$router.currentRoute.fullPath
    }
  },
  created () {
    var self = this
    var host = window.location.hostname.replace(/^[^.]+\./g, "");
    var hostname = this.$route.params['domain_name'] || host
    this.loadCustomEventStructuredData(`url_site=${hostname}`)
    this.loadGAIdByUrlSite(hostname)
    this.getEvents()
  },
  computed: {
    paginatedEvents () {
      let indexFrom = (this.currentPage - 1) * this.eventsToDisplay
      let indexTo = this.eventsToDisplay * (this.currentPage - 1) + this.eventsToDisplay
      return this.events.slice(indexFrom, indexTo)
    }
  },
  methods: {
    getEvents () {
      var self = this
      var loader = this.$loading.show()
      var domainName = this.$route.params['domain_name']

      EventPublicService.getEventsByUrl(domainName, this.currentPage, this.perPage).then((response) => {
        self.events = response.data
        self.totalEvents = parseInt(self.events.length || '0')

        self.loading = false
      }).catch((error) => {
        if (error) {
          self.events = []
        }
      }).finally(() => {
        loader.hide()
      })
    },
    displayMoreEvents () {
      this.eventsToDisplay = this.eventsToDisplay + this.perPage
    }
  }
}
</script>
